import { Component, Renderer2, OnInit, AfterContentInit } from '@angular/core';
import { AppServiceService } from './app-service.service';
import { ApiService } from './api.service';
import { UiService } from './ui.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentInit{
  title = 'app';
  images:any = [];
  cookie:any = '';
  hidden:boolean = false;

  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  constructor(
    private app: AppServiceService, 
    public renderer: Renderer2,
    private api:ApiService,
    private UI: UiService,
    private cookieService: CookieService
  ){
    this.renderer.listen('document', 'mousemove', (e) => {
      this.app.cursorX = e.clientX+'px';
      this.app.cursorY = e.clientY+'px';
    });
    
  }

  trackByFn(index) {
    return index;
  }

  getPage(outlet) {
    //this.app.menuState.next('hide');
  }

  accept(){
    this.hidden = true;
    this.cookieService.set('cookie', 'accept');
  }

  ngOnInit() {
    this.cookie = this.cookieService.get('cookie');
    this.UI.getScreenParams();
    if(this.cookie == 'accept'){
      this.hidden = true;
    }
  }

  ngAfterContentInit(){
    setTimeout(() => {
      this.UI.removePreloader();
      this.api.mainImagePages().subscribe(data => {
        this.images = data;
      })
    }, 4000);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts